module.exports = {
      id: "icon-open-in-new-usage",
      viewBox: "0 0 24.047 24.047",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-open-in-new",
      toString: function () {
        return this.url;
      }
    }